import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {POLARIS_HOME_SUGGESTED_QUESTIONS, POLARIS_HOME_SUGGESTED_QUESTIONS_AMOUNT, SuggestedQuestion} from '../../../types';
import {UtilService} from '../../../../../services/util.service';

@Component({
  selector: 'app-suggested-questions',
  imports: [],
  templateUrl: './suggested-questions.component.html',
  styleUrl: './suggested-questions.component.scss'
})
export class SuggestedQuestionsComponent {
  public questions: SuggestedQuestion[] = [];
  private utilService: UtilService = inject(UtilService);

  @Input() questionsPool: SuggestedQuestion[] = POLARIS_HOME_SUGGESTED_QUESTIONS;
  @Input() questionsAmount: number = POLARIS_HOME_SUGGESTED_QUESTIONS_AMOUNT;

  @Output() questionSelected = new EventEmitter<string>();

  ngOnInit(): void {
    this.questions = this.getRandomQuestions();
  };

  public sendQuestionToInputBar(question: string): void {
    this.questionSelected.emit(question);
  }

  private getRandomQuestions(): SuggestedQuestion[] {
    if (!this.questionsPool.length) {
      return [];
    };
    if (this.questionsPool.length <= this.questionsAmount) {
      return this.questionsPool;
    };
    const indices = new Set<number>();
    while (indices.size < this.questionsAmount) {
      indices.add(this.utilService.getRandomFromRange(0, this.questionsPool.length));
    }
    return [...indices].map(i => this.questionsPool[i]);
  }
}
